import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Device } from '../models/device';
import { MatSnackBar } from '@angular/material';
import { RsmAlarmGrouping } from '../models/AlarmGroup';
import { Port } from '../models/port';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {



  devices: Device[] = [];


  constructor(private http: HttpClient, public snackBar: MatSnackBar) {

  }

  getDeviceType(tipe: number): string {
    switch (tipe) {
      case 1:
      return "RSM"

      case 2:
      return "Checknet"

      case 3:
      return "Sigfox"

      case 4:
      return "LoRa"
      case 5:
      return "Fastnet"
      case 6:
      return "uRSM"

      default:
      return "Unknown"
        break;
    }
  }


  xgetDeviceBySiteId(site_id: number): Observable<[Device]> {
    return this.http.get<[Device]>('core-service/api/device?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('Devices'))
    )
  }

  //Get devices by in site
  getDeviceBySiteId(site_id: number) {


    this.http.get<[Device]>('core-service/api/device?site_id=' + site_id).pipe(
      catchError(this.handleError<any>('Devices'))
    ).subscribe((res: any) => {
      this.devices = res;
    });
  }

  getDeviceById(dev_id: number): Observable<[Device]> {
    return this.http.get<Device>('core-service/api/device?dev_id=' + dev_id).pipe(
      catchError(this.handleError<any>('Device'))
    );
  }

  addDeviceToSite(iotDeviceId: number, siteId: number, templateId: number) {
    var newDevice = {
      iot_id: iotDeviceId,
      site_id: siteId,
      template_id: templateId,
    }

    return this.http.post('core-service/api/device', newDevice)
    .pipe(catchError(this.handleError<any>('add device to site')))
  }

  addDeviceToSiteNoTemplate(iotDeviceId: number, siteId: number) {
    var newDevice = {
      iot_id: iotDeviceId,
      site_id: siteId,
    }

    return this.http.post('core-service/api/device/add-device-to-site', newDevice)
    .pipe(catchError(this.handleError<any>('add device to site no template')))
  }

  moveDeviceToSite(deviceId: number, siteId: number) {
    var newDevice = {
      device_id: deviceId,
      site_id: siteId,
    }
    let url = `core-service/api/device/${deviceId}/move/to/site/${siteId}`
    return this.http.post(url, null)
    .pipe(catchError(this.handleError<any>('add device to site no template')))
  }

  deleteDevice(deviceId: number) {
    let url = `core-service/api/device/${deviceId}`
    return this.http.delete(url)
      .pipe(catchError(this.handleError<any>('add device to site no template')))
  }

  createSiteFromDevice(iotDeviceId: number) {
    return this.http.post('core-service/api/site/create-site-from-device', { iot_id: iotDeviceId })
    .pipe(catchError(this.handleError<any>('create site from device')))
  }

  moveDevicesToAlarmGroup(alarmGroup: number, portsArr: Device[]): Observable<any> {

    var temp: number[] = [];
    portsArr.forEach(device => {
      temp.push(device.dev_id)
    });

    if (!alarmGroup)
      alarmGroup = -1;


    //will mirror the function for moving ports 
    return this.http.post<any>('core-service/api/device/alarm-group?group_id=' + alarmGroup, { dev_id: temp })


  }

  updateDeviceAlarmGroup(dev: Device): Observable<Device> {
    return this.http.put<Device>('/rsmservice/devices', dev).pipe(
      catchError(this.handleError<any>('Update Device Alarm Group'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.open(`${operation} failed: ${error.message}`, '', {
        duration: 3000,
      });

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
